export default "/images/poweredby.png";